import React, { useEffect, useState } from 'react';
import ProductCategoryForm from '@app/components/apps/ProductCategories/ProductCategoryForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { Col, Row } from 'antd';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

const CreateProductCategoryPage: React.FC = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Product Category');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/products',
      breadcrumbName: 'Product Categories',
    },
    {
      path: '/add-product-category',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ProductCategoryForm
            type="create"
            setCurrentBreadcrumName={setCurrentBreadcrumName}
            pageTitle={'Create Product Category'}
            editable={true}
            id={null}
          />
        </Col>
      </Row>
    </>
  );
};

export default CreateProductCategoryPage;
